import React, { useEffect, useState } from "react";
import { Button } from "../ui/button";
import { ArrowLeft } from "@phosphor-icons/react";
import { useRouter } from "next/router";

const SubNavigation = ({ children, title }) => {
  const router = useRouter();
  const [prevScrollPos, setPrevScrollPos] = useState(0);
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollPos =
        window.pageYOffset || document.documentElement.scrollTop;
      const isVisible = prevScrollPos > currentScrollPos;

      setPrevScrollPos(currentScrollPos);
      setVisible(isVisible);
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [prevScrollPos]);

  return (
    <div
      className={`container sticky z-40 text-sm bg-black/80 backdrop-blur-lg top-[64px] lg:top-[148px] transition-transform duration-500`}
    >
      <div className='flex items-center justify-between w-full border-b border-white/10 h-14'>
        <div
          className={`items-center space-x-3 flex min-w-0 ${
            (router.pathname === "/investors/[slug]" ||
              router.pathname === "/startups/[slug]") &&
            "hidden lg:flex"
          }`}
        >
          <Button
            variant='link'
            className='p-0 group'
            onClick={() => router.back()}
          >
            <span className='inline-flex items-center justify-center flex-shrink-0 transition-colors rounded-full w-7 h-7 group-hover:bg-white/30 bg-white/20'>
              <ArrowLeft className='text-sm' />
            </span>
            <span className='hidden ml-2 text-xs font-normal lg:block opacity-60 whitespace-nowrap'>
              Go Back
            </span>
          </Button>
          <span className='hidden lg:block text-white/10'>|</span>
          <span className='text-xs text-white truncate'>{title}</span>
        </div>
        {children && (
          <div className='flex items-center w-full lg:w-auto lg:space-x-2'>
            {children}
          </div>
        )}
      </div>
    </div>
  );
};

export default SubNavigation;
